var exports = {
  "k": "x4c3adb35--7e899e--container",
};

module.exports = exports;
